import { render, staticRenderFns } from "./SSelectFruitState.vue?vue&type=template&id=05630b56"
import script from "./SSelectFruitState.vue?vue&type=script&lang=js"
export * from "./SSelectFruitState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports